<template>
    <b-card class="mb-1" :title="$t('Component(ResearchReviewProcess):classification')">
        <b-form-group :label="$t('Component(Label):scope')" class="mb-0">
            <v-select
                v-model="localValue.scope"
                :options="scopeOptions"
                label="label"
                :reduce="option => option.id"
                :append-to-body="true"
            />
        </b-form-group>
    </b-card>
</template>

<script>
import {BCard, BFormGroup} from 'bootstrap-vue'
import vSelect from 'vue-select'

function clone(value) {
    return JSON.parse(JSON.stringify(value || {}))
}

function isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}

function normalize(value) {
    const normalized = clone(value)

    if (!Object.prototype.hasOwnProperty.call(normalized, 'scope')) {
        normalized.scope = null
    }

    return normalized
}

export default {
    name: 'ClassificationSection',
    components: {
        BCard,
        BFormGroup,
        vSelect,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            localValue: normalize(this.value),
        }
    },
    computed: {
        scopeOptions() {
            const options = [
                {id: null, label: '-'},
                ...this.$store.getters['researchReview/classificationScopes']
                    .map(scope => ({
                        id: scope,
                        label: this.$t('Component(ResearchReviewProcessEnum):scope-' + scope),
                    })),
            ]

            const current = this.localValue ? this.localValue.scope : null
            if (current && !options.find(option => option.id === current)) {
                options.push({
                    id: current,
                    label: this.$t('Component(ResearchReviewProcessEnum):scope-' + current),
                })
            }

            return options
        },
    },
    watch: {
        value: {
            deep: true,
            handler(newValue) {
                const normalized = normalize(newValue)
                if (isEqual(normalized, this.localValue)) {
                    return
                }

                this.localValue = normalized
            },
        },
        localValue: {
            deep: true,
            handler(newValue) {
                const emitted = clone(newValue)
                const current = normalize(this.value)

                if (isEqual(emitted, current)) {
                    return
                }

                this.$emit('input', emitted)
            },
        },
    },
}
</script>
